import { Feature } from 'ol'
import PointFeatureSource from './PointFeatureSource';
import Point from 'ol/geom/Point'
import AnchorPointFeature from './AnchorPointFeature';

/**
 * A point feature source specifically for Anchor points, where the first and last
 * are drawn in a different colour from those in-between.
 */

 export class AnchorPointFeatureSource extends PointFeatureSource<AnchorPointFeature> { 

    addFeature(feature: AnchorPointFeature) { 
        super.addFeature(feature);
        this.setAnchorColours();
    }

    addFeatures(features: AnchorPointFeature[]) {
        super.addFeatures(features);
        this.setAnchorColours()
        // if we are adding more than one (such as in the case of join track, I think we need to set the start/mid/end for them all)
        // if we are only adding 1, then only what's now the penultimate and the new one are affected.
    }

    removeFeature(feature: Feature<Point>) { 
        super.removeFeature(feature);
        this.setAnchorColours();
    }

    private setAnchorColours() { 
        const features = this.getFeatures();
        const featureCount = features.length
        features.forEach((item, index) => {
            if(index === 0) {
                item.setFirst()
            } else if (index === featureCount - 1) {
                item.setLast()
            } else {
                item.setMid()
            }
        })
    }
}